// @ts-check

const globalColors = {
  palette: {
    info: {
      dark: '#01579B',
      main: '#0288D1',
      light: '#2196F3',
      lighter: '#D0E6F9',
    },
  },
  borderColor: '#D9DDE3',
  white: '#FFFFFF',
  black: '#000000',
  grey: '#E8EAEE',
  dividerColor: {
    backgroundColor: '#554f4f63'
  }
};

export default globalColors;
